import { render } from "./MessageDetail.vue?vue&type=template&id=3d836fc5"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"

import "./MessageDetail.vue?vue&type=style&index=0&id=3d836fc5&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__